import { createAction } from "@ngrx/store";

export const showSpinner = createAction(
    '[Spinners] Show Spinner');

export const hideSpinner = createAction(
        '[Spinners] Hide Spinner');
